export default __webpack_public_path__ + "static/media/VU.3d64a664.svg";